/* eslint-disable @change/sibling-module-imports */
import type { ComponentProps } from 'react';

import type { Box } from '@change-corgi/design-system-legacy/layout';
import { Flex } from '@change-corgi/design-system-legacy/layout';
import { Text } from '@change-corgi/design-system-legacy/typography';

import type { Comment } from '../../../../pageContext';

import { CommentHeader } from './CommentHeader';
import { useCommentCard } from './hooks/useCommentCard';

type Props = {
	comment: Comment;
};

export function CommentCard({ comment, ...rest }: Props & ComponentProps<typeof Box>) {
	const {
		data: { comment: commentText },
	} = useCommentCard(comment);

	return (
		<>
			<Flex
				{...rest}
				px={24}
				sx={{
					alignItems: 'center',
					minHeight: '40px',
					width: '100',
				}}
				data-qa={`comment-card-${comment.id}`}
				data-expanded
			>
				<CommentHeader comment={comment} />
			</Flex>
			<Flex ml={61} sx={{ alignSelf: 'stretch', mb: '15px' }}>
				<Text as="div" size="default" breakWord sx={{ whiteSpace: 'pre-wrap', pr: 24 }} data-qa="comment-body">
					&quot;{commentText}&quot;
				</Text>
			</Flex>
		</>
	);
}
